<div #chartElement class="chartElement"></div>
<div class="chart-legends" *ngIf="barChartConfiguration.customLegend">
    <div class="rates">
        <div class="title add-color subtext-font ">Baseline Rate</div>
        <div class="percent title-font">{{chartData.average_baseline}}
            <span *ngIf="chartData.average_baseline">%</span>
        </div>
    </div>
    <div class="rates">
        <div class="title add-color subtext-font">Exposed Rate</div>
        <div class="percent title-font">{{chartData.average_exposed_rate}}
            <span *ngIf="chartData.average_exposed_rate">%</span>
        </div>
    </div>
</div>
